module.exports = __webpack_public_path__ + "img/sm.16dab5ad.svg";